var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImg24(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 78,
    viewBox: "0 0 69 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_391_28621)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.72181 69.8289L0 0.130859L68.3333 0.270923L62.2831 69.8289L34.4246 77.8692L5.72181 69.8289Z",
    fill: "#1B73BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4258 71.1386V6.76953L62.5659 6.86291L57.5478 64.454L34.4258 71.1386Z",
    fill: "#1C88C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5777 14.9961H12.2891L13.4618 23.4098H34.0036L13.7902 32.0581L14.9623 40.1917H44.7441L43.6651 51.5506L33.5815 53.5143L24.4364 51.1771L23.7327 44.7259H15.3376L16.4629 58.1424L34.4726 63.1441L51.7323 57.675L53.9366 31.4501H35.6916L55.5771 23.2231L55.5777 14.9961Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_391_28621"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68.3333,
    height: 78,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg24);
export default __webpack_public_path__ + "static/media/img24.cdd03c16ba41e3a3d60b0bbc620b7032.svg";
export { ForwardRef as ReactComponent };